export default (...arrays) =>
  Array.from(new Set([].concat(...arrays))).filter(toFind =>
    arrays.every(arr => arr.some(el => el === toFind))
  )
